import React, { useState } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import styled from "styled-components";

import KickCarousel from "../KickCarousel";

import { getCloudImageUrl } from "../.././../utils/Helpers";

const onHandleSliderClick = (id) => {
  console.log("RECORD ITEM CLICK HERE!")
}

const LuxurySlider = ({ dataSlider, dataAuth }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [pause, setPause] = useState(false);


  return (
    <SliderWrapper>
      {
        dataSlider.images.length && !dataSlider.images.error && (
          <KickCarousel
            activeIndex={activeSlide}
            pause={pause}
            sliders={dataSlider.images}
            // sliderState={this.state.imageSliders}
            onActiveIndexChanged={index => setActiveSlide(index)}
            dataAuth={dataAuth}
            // history={this.props.history}
            onSliderClick={onHandleSliderClick}
          />
        )
      }
    </SliderWrapper>
  )
}

const SliderWrapper = styled.div`
  padding-top: 0;

  @media(max-width: 480px){
    padding-top: 0;
  }
`

const mapStateToProps = (state) => ({
  dataSlider: state.sliderHome,
  dataAuth: state.dataAuth
})

export default connect(mapStateToProps, null)(LuxurySlider);